import styles from './style.postcss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Map } from 'immutable';
import classnames from 'classnames';
import { connect, testClass, Grid, PageCard, StudentCard } from 'omni-common-ui';
import CardActionIcons from 'components/CardActionIcons';
import StudentCardProfile from 'containers/StudentCardProfile';
import HomeworkType from 'data/Homework/Types';
import ContentItem from '../ContentItem';

export class PersonalisedHomeworkViewCard extends Component {
  componentWillMount() {
    const { fetchTypesIfNeeded, courseTypeLevelId } = this.props;
    fetchTypesIfNeeded(courseTypeLevelId);
  }

  componentWillUpdate(nextProps) {
    const { fetchTypesIfNeeded, courseTypeLevelId } = nextProps;
    fetchTypesIfNeeded(courseTypeLevelId);
  }

  render() {
    const {
      students,
      homeworkContentTypes,
      personalisedHomework,
      index,
      contentClassName,
      editPersonalisedHomeworkLinkHref,
      deletePersonalisedHomeworkLinkHref,
    } = this.props;

    const renderContent = () => personalisedHomework.contents.map((item) => {
      let contentType;
      const contentTypeName = (
        Map.isMap(homeworkContentTypes) &&  // eslint-disable-line no-cond-assign
        (contentType = homeworkContentTypes.get(item.homeworkTypeId)) &&
        contentType.name ?
          contentType.name : '');
      return <ContentItem key={personalisedHomework.id + item.homeworkTypeId}
          homeworkType={contentTypeName}
          boardValue={item.content} />;
    });

    const renderStudents = () => <div className={styles.PersonalisedHomeworkViewCard_students}>
      <h5 className={styles.PersonalisedHomeworkViewCard_heading}>
        Assigned to
      </h5>
      <Grid>
        <Grid.Group>
          {students.map((member) => {
            const studentId = member.studentGeneralInfo.id;
            return <Grid.Item key={studentId}
                className={styles.PersonalisedHomeworkViewCard_studentCell}
                xs={12}
                sm={6}
                lg={4}>
              <StudentCard borderless backgroundless>
                <StudentCardProfile className={styles.PersonalisedHomeworkViewCard_studentProfile}
                    studentId={member.studentGeneralInfo.id} />
              </StudentCard>
            </Grid.Item>;
          })}
        </Grid.Group>
      </Grid>
    </div>;

    const renderActionIcons = () =>
      <CardActionIcons editHref={editPersonalisedHomeworkLinkHref}
          deleteHref={deletePersonalisedHomeworkLinkHref}
          hideEditIcon={! personalisedHomework.canEdit}
          hideDeleteIcon={! personalisedHomework.canDelete} />;

    const heading = `Personalised Homework ${index + 1}`;
    const className = classnames(this.props.className,
      testClass(`personalised-homework-${index + 1}`),
      testClass('personalised-homework'));

    return <PageCard className={className}>
      <PageCard.Heading text={heading} stackMode="horizontal">
        {renderActionIcons()}
      </PageCard.Heading>
      <PageCard.Content className={contentClassName}>
        {renderContent()}
        {renderStudents()}
      </PageCard.Content>
    </PageCard>;
  }
}

PersonalisedHomeworkViewCard.propTypes = {
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  index: PropTypes.number,
  students: PropTypes.object,
  courseTypeLevelId: PropTypes.string,
  personalisedHomework: PropTypes.object,
  editPersonalisedHomeworkLinkHref: PropTypes.string,
  deletePersonalisedHomeworkLinkHref: PropTypes.string,
  homeworkContentTypes: PropTypes.instanceOf(Map),
  fetchTypesIfNeeded: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(HomeworkType.actions, dispatch);
}

function mapStateToProps(state, { courseTypeLevelId }) {
  return {
    homeworkContentTypes:
      HomeworkType.accessors.getTypesByCourseTypeLevelId(state, courseTypeLevelId),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PersonalisedHomeworkViewCard);



// WEBPACK FOOTER //
// ./containers/Group/AssignHomework/Assignments/PersonalisedHomeworkViewCard/index.jsx